import React, { useState, useEffect } from "react";
import TabComponent from "./TabComponent";

function DetailsFile() {
  const [showFullText, setShowFullText] = useState(false);
  const detailText = "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Libero alias, sit mollitia velit sed amet dolore consectetur, consequuntur molestias pariatur molestiae. Error, nemo? Ipsum ipsa at quasi nesciunt reiciendis.";

  const truncatedText = detailText.length > 50 ? `${detailText.substring(0, 50)}...` : detailText;

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top when component mounts
  }, []);
  return (
    <>
      <div className="flex flex-col gap-5 justify-start bg-blue-500 details-file mb-8">
        <h1 className="movie-detail-name text-5xl text-gray-100 ">Movie name</h1>
        <p className="text-gray-100 leading-6">
          <span className={`movie-desc text-ellipsis overflow-hidden  ${showFullText ? ' hidden ' : ' ' } no-wrap text-base text-gray-100 leading-6`}  onClick={() => setShowFullText(true)} >
            {truncatedText} <span className="cursor-pointer"> More</span>
          </span>
          {showFullText && (
            <span className="block">
              {detailText}<button className="text-base text-gray-100 bg-slate-400 rounded p-1 leading-6" onClick={() => setShowFullText(false)}>Show less</button>
            </span>
          )}
        </p>
        <div>
          <h3 className="text-base text-gray-100">
            Starting: <span>Actor Name</span>
          </h3>
          <h3 className="text-md text-gray-100">Director: <span>Director Name</span></h3>
        </div>
        <p className="text-md text-gray-100">R <span>Documenteries</span><span>Movie</span> <span>Year</span> <span>HD</span></p>
        <p className="text-md text-gray-100">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptates, dolorum.</p>
        <h3 className="inline	w-fit-content rounded-md text-ellipsis overflow-hidden text-2xl bg-gray-100 text-gray-900 font-bold py-2 px-4 uppercase hover:bg-slate-900 hover:text-gray-100  hover:rounded group-hover/item:visible transition delay-150 duration-300 ease-in-out cursor-pointer" style={{ width: 'fit-content' }}>Start your free trial</h3>
        <p className="text-md text-gray-100">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia, quibusdam. Fuga nemo dolorum eveniet culpa?</p>
      </div>
      <TabComponent />
    </>
  );
}

export default DetailsFile;
